import React from 'react'
import { DragHandleIcon } from '@chakra-ui/icons'
import { Flex, Checkbox } from '@chakra-ui/react'

import { useListGroupItem } from './useListGroup'

const ListGroupItemDragHandle = props => (
  <Flex p={2} align='center' borderRightWidth='1px' {...props}>
    <DragHandleIcon boxSize={4} />
  </Flex>
)

export const ListGroupItem = React.forwardRef(
  ({ id, handleProps, actions, onSelect, isSelected, children, ...props }, ref) => {
    const { isMovable, isSelectable } = useListGroupItem()

    return (
      <Flex as='li' ref={ref} {...props} borderWidth='1px' my={1} align='stretch'>
        {isMovable && <ListGroupItemDragHandle {...handleProps} />}
        {isSelectable && (
          <Flex p={2} borderRightWidth='1px'>
            <Checkbox isChecked={isSelected} onChange={onSelect} />
          </Flex>
        )}
        <Flex p={2} flex={1}>
          {children}
        </Flex>
        {actions && (
          <Flex borderLeftWidth='1px' align='center'>
            {actions}
          </Flex>
        )}
      </Flex>
    )
  }
)

export default ListGroupItem
